module.exports = __webpack_public_path__ + "img/list-title-s1.0a7954b3.png";